import { useAuthUsername } from '@akin-home/auth/react';
import { StateUpdate } from '@akin-home/state-variables-frontend';
import { useUpdateStateVariables as useUpdateStateVariablesBase } from '@akin-home/state-variables-react';
import { assembleUserChatID } from '@akin-home/user';
import { useCallback } from 'react';
import { useApplicationID } from '../../chat/useAkinChat';
import { useCurrentUserID } from '../../users';

export const useUpdateStateVariables = () => {
  const update = useUpdateStateVariablesBase();
  const application_id = useApplicationID();
  const id = useCurrentUserID();
  const username = useAuthUsername() || '';

  return useCallback(
    (updates: StateUpdate[]) => {
      return update.mutateAsync({
        application_id,
        username: assembleUserChatID(username, id),
        updates,
      });
      // eslint-disable-next-line react-hooks/exhaustive-deps
    },
    [id, username, application_id]
  );
};
